import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {BatchAlertsService} from "./batch-alerts.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class BatchRequestsService {

  /* @ngInject */
  constructor(private apiConfig: ApiConfig, private splitService: SplitService, private Upload,
              private $http: IHttpService, private $q: IQService, private batchAlertsService: BatchAlertsService, private bringozLoaderService: BringozLoaderService) {
  }

  createOmsBatch(data, allowUpdate) {
    const api = this.apiConfig.baseUrl + `/importers-oms/import`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId(),
          allowUpdate: allowUpdate
        },
        data: data
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  createServicesBatch(data, update) {
    const api = this.apiConfig.baseUrl + `/importers-orders/import`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId(),
          toUpdate: update
        },
        data: data
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  createRecurringServicesBatch(data) {
    const api = this.apiConfig.baseUrl + `/importers-recurring-services/import`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId()
        },
        data: data
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }


  validateAgentAssignments(importerPath: string, file, customSchemaId?: string) {
    const api = this.apiConfig.baseUrl + `/${importerPath}/validate`;
    const deferred = this.$q.defer();

    this.Upload.upload({
      url: api,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        customSchemaId: customSchemaId
      },
      data: {file: file}
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  uploadAgentSchedules(importerPath: string, file, customSchemaId?: string) {
    const api = this.apiConfig.baseUrl + `/${importerPath}/upload`;
    const deferred = this.$q.defer();

    this.Upload.upload({
      url: api,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        customSchemaId: customSchemaId
      },
      data: {file: file}
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  createAgentAssignmentsBatch(importerPath: string, items) {
    const api = this.apiConfig.baseUrl + `/${importerPath}/import`;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId()
      },
      data: items
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  getAgentAssignmentsBatchProgress(importerPath: string, batchId) {
    const api = this.apiConfig.baseUrl + `/${importerPath}/status/` + batchId;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'GET',
      params: {
        siteId: this.splitService.getSiteId()
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  getOmsBatchProgress(batchId) {
    const api = this.apiConfig.baseUrl + `/importers-oms/status/` + batchId;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'GET',
      params: {
        siteId: this.splitService.getSiteId()
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  getServicesBatchProgress(batchId) {
    const api = this.apiConfig.baseUrl + `/importers-orders/status/` + batchId;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'GET',
      params: {
        siteId: this.splitService.getSiteId()
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  getRecurringServicesBatchProgress(batchId, hidePayload) {
    const api = this.apiConfig.baseUrl + `/importers-recurring-services/status/` + batchId;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'GET',
      params: {
        siteId: this.splitService.getSiteId(),
        hidePayload: hidePayload
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  getAgentsBatchProgress(batchId) {
    const api = this.apiConfig.baseUrl + `/importers-agents/status/` + batchId;
    const deferred = this.$q.defer();

    this.$http({
      url: api,
      method: 'GET',
      params: {
        siteId: this.splitService.getSiteId()
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      })

    return deferred.promise;
  }

  createAccountsBatch(data, allowUpdate) {
    const api = this.apiConfig.baseUrl + `/importers-accounts/import`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId(),
          allowUpdate: allowUpdate
        },
        data: data
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  createAgentsBatch(data, allowUpdate) {
    const api = this.apiConfig.baseUrl + `/importers-agents/import`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId(),
          allowUpdate: allowUpdate
        },
        data: data
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  createSchema(schema) {
    const api = this.apiConfig.baseUrl + `/importers-schema`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'PUT',
        params: {
          siteId: this.splitService.getSiteId()
        },
        data: schema
      })
        .then((response) => {
          this.batchAlertsService.createSchemaSuccess();
          resolve(response.data);
        })
        .catch((response) => {
          this.batchAlertsService.createSchemaError();
          reject(response.data);
        });
    });
  }

  editSchema(schema) {
    const api = this.apiConfig.baseUrl + `/importers-schema/${schema.id}`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId()
        },
        data: schema
      })
        .then((response) => {
          this.batchAlertsService.editSchemaSuccess();
          resolve(response.data);
        })
        .catch((response) => {
          this.batchAlertsService.editSchemaError();
          reject(response.data);
        });
    });
  }

  deleteSchema(schemaId) {
    const api = this.apiConfig.baseUrl + `/importers-schema/${schemaId}`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'DELETE',
        params: {
          siteId: this.splitService.getSiteId()
        }
      })
        .then((response) => {
          this.batchAlertsService.deleteSchemaSuccess();
          resolve(response.data);
        })
        .catch((response) => {
          this.batchAlertsService.deleteSchemaError();
          reject(response.data);
        });
    });
  }


  getSchemaDefaultFields(entityType: string) {
    const api = this.apiConfig.baseUrl + `/importers-schema/default`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'GET',
        params: {
          siteId: this.splitService.getSiteId(),
          entityType
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  getSchemas(entityType: string) {
    const api = this.apiConfig.baseUrl + `/importers-schema`;
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'GET',
        params: {
          siteId: this.splitService.getSiteId(),
          entityType
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  importCustomDailyOrders(file, configurationId) {
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/importers-daily-orders-planning/upload`,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        configurationId: configurationId
      },
      data: {
        file: file
      }
    })
      .then((response) => {
        return this.$q.when(response.data);
      })
  }

  uploadVisitConfigurations(visitConfigurations) {
    const api = this.apiConfig.baseUrl + `/importers-visit-configuration/upload`;
    this.bringozLoaderService.on();
    return new Promise((resolve, reject) => {
      this.$http({
        url: api,
        method: 'POST',
        params: {
          siteId: this.splitService.getSiteId(),
        },
        data: visitConfigurations
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }


  // getEntityImportPreview(entityType: string, file, schemaId?: string) {
  //   const deferred = this.$q.defer();
  //
  //   this.bringozLoaderService.on();
  //   this.Upload.upload({
  //     url: this.apiConfig.baseUrl + `/importers-schema/preview`,
  //     method: 'POST',
  //     params: {
  //       siteId: this.splitService.getSiteId(),
  //       entityType,
  //       customSchemaId: schemaId,
  //       zoneId: this.splitService.getTimeZone()
  //     },
  //     data: {
  //       file: file
  //     }
  //   })
  //     .then((res) => {
  //       deferred.resolve(res.data);
  //     })
  //     .catch((res) => {
  //       this.batchAlertsService.getEntityImportPreviewError()
  //       deferred.reject(res.error)
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     });
  //
  //   return deferred.promise
  // }


  mapEntities(file, entity, accountId?, customSchemaId?, schema?): any {
    const siteId = this.splitService.getSiteId();


    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.Upload.upload({
      url: this.apiConfig.baseUrl + `/importers-job/upload`,
      method: 'POST',
      params: {
        siteId: siteId,
        accountId: accountId,
        customSchemaId,
        zoneId: this.splitService.getTimeZone()
      },
      data: {
        file: file,
        schema: JSON.stringify(schema)
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((error) => {
        deferred.resolve(error);
        this.batchAlertsService.entityMappingError()
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise

    // return this.fileToBinary(file).then((base64File: any) => {
    //
    //   return new Promise((resolve, reject) => {
    //     this.$http(
    //       {
    //         url: this.apiConfig.baseUrl + `/importers-${entity}/upload`,
    //         method: 'POST',
    //         params: {
    //           siteId: siteId,
    //           accountId: accountId,
    //           customSchemaId,
    //           zoneId: this.splitService.getTimeZone()
    //         },
    //         data: {
    //           schema: schema,
    //           file: base64File
    //         }
    //       }
    //     ).then(function (response) {
    //     }).catch(function (error) {
    //       console.error('Upload failed:', error);
    //     });
    //   });
    // }).catch(error => {
    //   console.error('Error reading file as binary:', error);
    // });

    // return new Promise((resolve, reject) => {
    //   this.$http(
    //     {
    //       url: this.apiConfig.baseUrl + `/importers-job/upload`,
    //       method: 'POST',
    //       params: {
    //         siteId: siteId,
    //         accountId: accountId,
    //         customSchemaId,
    //         zoneId: this.splitService.getTimeZone()
    //       },
    //       data: {
    //         file: file,
    //         schema: schema
    //       }
    //     }
    //   ).then(function (response) {
    //   }).catch(function (error) {
    //     console.error('Upload failed:', error);
    //   });
    // });
  }

  // uploadJobs(file, accountId?, customSchemaId?, schema?) {
  //   const siteId = this.splitService.getSiteId();
  //
  //   return this.fileToBinary(file).then((binaryFile: any) => {
  //     const boundary = '----WebKitFormBoundary7MA4YWxkTrZu0gW';  // Define a boundary string
  //
  //     // Define the body parts, each part will have the correct headers and boundaries
  //     const bodyParts = [
  //       // File part (binary data)
  //       `--${boundary}\r\nContent-Disposition: form-data; name="file"; filename="${file.name}"\r\nContent-Type: ${file.type}\r\n\r\n`,
  //       binaryFile,  // Binary file data here (ArrayBuffer)
  //
  //       // Other data part (JSON object)
  //       `--${boundary}\r\nContent-Disposition: form-data; name="data"\r\nContent-Type: application/json\r\n\r\n`,
  //       JSON.stringify({schema}),  // JSON object part
  //
  //       `--${boundary}--\r\n`  // Closing boundary with line break
  //     ];
  //
  //     // Convert body parts to a single array and ensure all parts are properly encoded as Blob
  //     const blobs = bodyParts.map(part => new Blob([part], {type: 'application/octet-stream'}));
  //
  //     // Combine the blobs into one large blob (representing the full multipart body)
  //     const fullBlob = new Blob(blobs, {type: 'multipart/form-data; boundary=' + boundary});
  //
  //     return new Promise((resolve, reject) => {
  //       this.$http({
  //         url: this.apiConfig.baseUrl + `/importers-job/upload`,
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': `multipart/form-data; boundary=${boundary}`,  // Set Content-Type to multipart/form-data with the boundary
  //         },
  //         params: {
  //           siteId: siteId,  // Query parameters (these go in the URL)
  //           accountId: accountId,
  //           customSchemaId: customSchemaId,
  //           zoneId: this.splitService.getTimeZone()
  //         },
  //         data: fullBlob  // Send the raw multipart body (including both the binary file and JSON)
  //       }).then(function (response) {
  //         resolve(response.data);
  //       }).catch(function (error) {
  //         console.error('Upload failed:', error);
  //         reject(error);
  //       });
  //     });
  //   }).catch(error => {
  //     console.error('Error reading file as binary:', error);
  //   });
  // }


  uploadProjectJobs(entities: any, projectId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.$http({
      url: this.apiConfig.baseUrl + `/importers-job/import/${projectId}`,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        zoneId: this.splitService.getTimeZone()
      },
      data: entities
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


  fileToBinary(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Read file as binary string
      reader.readAsArrayBuffer(file);

      function arrayBufferToBase64(buffer) {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const length = bytes.length;
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      }

      // Resolve the binary data when the file is successfully read
      reader.onload = function () {
        const base64 = arrayBufferToBase64(reader.result)
        resolve(base64);
      };

      // Reject the promise if an error occurs
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }
}

angular
  .module('bringoz.admin.batch')
  .service('batchRequestsService', BatchRequestsService);
